const style1 = {
  backgroundColor: '#4F81BD',
  // backgroundColor: '#00B050',
  color: '#fff',
  minWidth: '80px',
  border: '1px solid #343a40',
};

export const listHeaderObj = [
  [
    { text: '#', style: { ...style1 } },
    { text: 'NAME', style: { ...style1, minWidth: '100px' } },
    { text: 'PART', style: { ...style1 } },
    // { text: 'INITIAL QUANTITY', style: { ...style1 } },
    // { text: 'Min QUANTITY', style: { ...style1 } },
    // { text: 'Max QUANTITY', style: { ...style1 } },
    { text: 'LOCK', style: { color: '#fff', backgroundColor: '#c92a2a' } },
  ],
];

export const listConstant = {
  childHeader: 'TNI REPORT LIST',
  datePickerLabel: 'Search By Year',
  addButtonLable: 'New TNI REPORT',
  modalHeaderName: 'CREATE NEW TNI REPORT',
};

export const headerConstant = {
  tableCompHeadTitle: 'SKILL EVALUATION SHEET',
};

export const tilesConstant = {
  childHeaderText: 'TNI FOR',
};

export const navigationConstant = {
  createEditTniReport: '/common/tniReportCreate',
};

export const apiConstant = {
  rackroute: 'storeSetupRoutes',
  compartmentroute: 'storeCompartmentRoutes',
};
